import bdServices125 from '../bd-services125'
import bdServices from '../bd-services'
var FormData = require('form-data')

const ticketServices = {}

ticketServices.searchAll = async function (limit) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/soporte/getTickets.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/soporte/getTickets.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

ticketServices.searchTicket = async function (id) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)

  if (currentUrl === '10.121.40.125') {
    const data = bdServices125.get(`/servidores/soporte/getTicketInd.php?id=${id}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = bdServices.get(`/servidores/soporte/getTicketInd.php?id=${id}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

ticketServices.searchTicket_user = async function (id, tipo) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)

  if (currentUrl === '10.121.40.125') {
    const data = bdServices125.get(`/servidores/soporte/getTicket_user.php?id=${id}&tipo=${tipo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = bdServices.get(`/servidores/soporte/getTicket_user.php?id=${id}&tipo=${tipo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

ticketServices.searchTicket_area = async function (area) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)

  if (currentUrl === '10.121.40.125') {
    const data = bdServices125.get(`/servidores/soporte/getTicket_area.php?a=${area}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = bdServices.get(`/servidores/soporte/getTicket_area.php?a=${area}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

ticketServices.saveTicket = async function (fechaReg, id_articulo, equipo, marca, modelo, serie, area, ubicacion, departamento, sitio, idSolicita, solicita, problema, estado) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  let formData = new FormData()
  formData.append('fechaReg', fechaReg)
  formData.append('id_art', id_articulo)
  formData.append('equipo', equipo)
  formData.append('modelo', modelo)
  formData.append('marca', marca)
  formData.append('serie', serie)
  formData.append('ubicacion', ubicacion)
  formData.append('area', area)
  formData.append('departamento', departamento)
  formData.append('sitio', sitio)
  formData.append('idSolicita', idSolicita)
  formData.append('solicita', solicita)
  formData.append('problema', problema)
  formData.append('estado', estado)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/soporte/addTicket.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

ticketServices.saveAtends = async function (idTicket, idAtiende, atiende) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  let formData = new FormData()
  formData.append('idTicket', idTicket)
  formData.append('idAtiende', idAtiende)
  formData.append('atiende', atiende)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/soporte/addAtiende.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

ticketServices.update_TicketResuelve = async function (id, idResuelve, resuelve, estado, fechaRes) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  let formData = new FormData()
  formData.append('id', id)
  formData.append('idResuelve', idResuelve)
  formData.append('resuelve', resuelve)
  formData.append('estado', estado)
  formData.append('fechaRes', fechaRes)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/soporte/update_TicketResuelve.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

ticketServices.saveResolucion = async function (idTicket, fechaReg, fechaRes, diag, rest, compra, coment, idUser, usuario, file) {
  var currentUrl = window.location.hostname
  let formData = new FormData()
  formData.append('idTicket', idTicket)
  formData.append('fechaReg', fechaReg)
  formData.append('fechaRes', fechaRes)
  formData.append('diag', diag)
  formData.append('rest', rest)
  formData.append('compra', compra)
  formData.append('coment', coment)
  formData.append('idUser', idUser)
  formData.append('usuario', usuario)
  formData.append('file', file)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/soporte/addResolucion.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

ticketServices.updateResolucion = async function (id, idTicket, fechaRes, diag, rest, compra, coment, file, evidAnt) {
  var currentUrl = window.location.hostname
  let formData = new FormData()
  formData.append('id', id)
  formData.append('idTicket', idTicket)
  formData.append('fechaRes', fechaRes)
  formData.append('diag', diag)
  formData.append('rest', rest)
  formData.append('compra', compra)
  formData.append('coment', coment)
  formData.append('file', file)
  formData.append('evidAnt', evidAnt)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/soporte/updateResolucion.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

ticketServices.update_EstadoTicket = async function (idTicket, estado, idUser, nombreUser, tipoCompra) {
  var currentUrl = window.location.hostname
  let formData = new FormData()
  formData.append('idTicket', idTicket)
  formData.append('estado', estado)
  formData.append('idU', idUser)
  formData.append('nU', nombreUser)
  formData.append('tC', tipoCompra)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/soporte/update_EstadoTicket.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

export default ticketServices


// WEBPACK FOOTER //
// ./src/services/soporte/tickets.js